import useSendVDPMegaEvent from '~/components/vdp/VehicleDetailsContainer/hooks/events/appRouter/useSendVDPMegaEvent';

export default function AppRouterDataHooks() {
  useSendVDPMegaEvent();

  return null;
}
